import api from '@/apis/di/accountAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { MSConstant } from '@/commons/wildcards';

// Combo grid Tài khoản chi phí
export const useAccountSaleComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onAccountSaleComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];

    // orsLike bao gồm các đầu tài khoản hiển thị lên combo
    let orsLike = [
      { Field: 'account_number', Operator: MSConstant.FilterOperator.StartsWith, Value: '512' },
      { Field: 'account_number', Operator: MSConstant.FilterOperator.StartsWith, Value: '514' },
      { Field: 'account_number', Operator: MSConstant.FilterOperator.StartsWith, Value: '531' },
      { Field: 'account_number', Operator: MSConstant.FilterOperator.StartsWith, Value: '711' },
    ];
    let orsIsParent = [{ Field: 'is_parent', Operator: 'NULL' }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      {
        Field: 'account_number',
        Operator: MSConstant.FilterOperator.StartsWith,
        Value: '511',
        Ors: orsLike,
      },
      { Field: 'is_parent', Value: false, Ors: orsIsParent },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'account_number';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const accountSaleComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'account_number',
        width: 120,
        filterOperator: MSConstant.FilterOperator.StartsWith,
      },
      { title: 'Tên tài khoản', dataField: 'account_name', filterOperator: MSConstant.FilterOperator.Contains,width: 480 },
    ],
    displayField: 'account_number',
    valueField: 'account_number',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onAccountSaleComboboxLoadData,
  };

  return {
    accountSaleComboConfig,
    onAccountSaleComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
